var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserW(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 76,
    viewBox: "0 0 59 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.75 0.166504C38.9167 0.166504 46.4167 9.33317 46.4167 20.9998C46.4167 32.6665 38.9167 41.8332 29.75 41.8332C20.5833 41.8332 13.0833 32.6665 13.0833 20.9998C13.0833 9.33317 20.5833 0.166504 29.75 0.166504ZM57.25 64.7498C50.1667 70.9998 40.1667 75.1665 29.75 75.1665C19.3333 75.1665 9.33334 70.9998 2.25 64.7498C0.583338 63.0832 0.166672 60.5832 1.83334 58.9165C6.41667 53.4998 12.6667 49.7498 19.3333 47.6665C22.6667 49.3332 26 50.1665 29.75 50.1665C33.5 50.1665 36.8333 49.3332 40.1667 47.6665C47.25 49.7498 53.0833 53.4998 57.6667 58.9165C59.3333 60.5832 59.3333 63.0832 57.25 64.7498Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserW);
export default __webpack_public_path__ + "static/media/User_w.ab08300f.svg";
export { ForwardRef as ReactComponent };